import React, { Component } from 'react';

export class StartTurnEventComponent extends Component {

    componentDidMount() {
        // this.props.app.gameController.startEngineBackgroundSound();
    }

    render() {
        return <></>;
    }

}
